<template>
    <div id="app"
         class="font-sans text-text bg-white"
    >
        <MenuHeader ref="menuHeader"
                    :active-key="activeKey"
                    :navigation="navigation"
                    @navigate-to="navigateTo"
                    @toggle="isOpen => this.toggleScrolling('#menu', !isOpen)"
                    @set-language="setLanguage"
        />

        <IndexHero @navigate-to="navigateTo"/>
        <WhoAreWe/>
        <WhatDoWeDo @navigate-to="navigateTo"/>
        <HowDoWeDoIt :data="howDoWeDoItData"/>
        <HorizontalBorder/>
        <References :data="referencesData"
                    @open="setActiveProject"
        />
        <WhoAreWeLookingFor/>
        <Contact/>
        <Footer/>

        <transition name="opacity">
            <DetailProject ref="detailProject"
                           v-if="activeProject"
                           :data="activeProject"
                           @close="setActiveProject(null)"
            />
        </transition>
    </div>
</template>

<script>
import {Translatable} from '@/data/translations';
import {clearAllBodyScrollLocks, disableBodyScroll} from 'body-scroll-lock';
import '../assets/tailwind.css';
import HorizontalBorder from '../components/baseComponents/HorizontalBorder';
import Contact from '../components/Contact';
import DetailProject from '../components/DetailProject';
import Footer from '../components/Footer';
import HowDoWeDoIt from '../components/HowDoWeDoIt';
import IndexHero from '../components/IndexHero';

import MenuHeader from '../components/MenuHeader';
import References from '../components/References';
import WhatDoWeDo from '../components/WhatDoWeDo';
import WhoAreWe from '../components/WhoAreWe';
import WhoAreWeLookingFor from '../components/WhoAreWeLookingFor';

export default {
    name: 'app',
    mixins: [Translatable],
    components: {
        IndexHero,
        MenuHeader,
        WhoAreWe,
        WhatDoWeDo,
        HowDoWeDoIt,
        HorizontalBorder,
        References,
        WhoAreWeLookingFor,
        Contact,
        Footer,
        DetailProject,
    },
    computed: {
        howDoWeDoItData() {
            return this.tr('howDoWeDoIt.data');
        },
        referencesData() {
            return this.tr('references.data');
        },
    },
    created() {
        this.registerScrollEvent();
        this.ignoreScroll = false;
    },
    destroyed() {
        this.removeScrollEvent();
    },
    data() {
        return {
            navigation: this.tr('navigation'),

            activeKey: null,
            activeProject: null,
        };
    },
    mounted() {
        $('#loading_div').addClass('loaded');
    },
    methods: {
        setLanguage(language) {
            console.log(language);
            this.setCurrentLanguage(language);
            this.$nextTick(() => window.location.reload());
        },

        navigateTo(key) {
            this.removeScrollEvent();

            this.activeKey = key;

            const newPosition = key ? this.offsetFor($(key)) : 0;

            $('html,body').animate(
                {scrollTop: newPosition},
                600 * Math.pow(Math.abs(newPosition - window.scrollY) / window.innerHeight, 0.8),
                () => this.registerScrollEvent(),
            );
        },

        toggleScrolling(ref, isEnabled) {
            if (isEnabled)
                clearAllBodyScrollLocks();
            else
                disableBodyScroll(document.querySelector(ref), {reserveScrollBarGap: true});
        },

        setActiveProject(data) {
            this.activeProject = data;
            this.toggleScrolling('#detailProject', !this.activeProject);
        },

        registerScrollEvent() {
            window.addEventListener('scroll', this.onScroll);
        },
        removeScrollEvent() {
            window.removeEventListener('scroll', this.onScroll);
        },

        onScroll() {
            if (this.ignoreScroll)
                return;

            const keys = Object.keys(this.navigation);
            let activeKey = null;

            $(keys.join(',')).each((index, element) => {
                if (this.offsetFor($(element)) <= this.originOfWindow())
                    activeKey = keys[index];
            });

            if (this.activeKey !== activeKey)
                this.activeKey = activeKey;
        },

        offsetFor(element) {
            const
                elementTop = element.offset().top,
                elementHeight = element.outerHeight(),

                navigationHeight = $('#mainNav').outerHeight(),
                windowHeight = window.innerHeight - navigationHeight,

                centeringOffset = Math.max((windowHeight - elementHeight) / 2, 0);

            return elementTop - navigationHeight - centeringOffset;
        },
        originOfWindow() {
            return window.scrollY + window.innerHeight * 0.25;
        },
    },
};
</script>

<style>
* {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

#app {
    max-width: 100vw;
    overflow: hidden;
    z-index: 0;
}

#hero {
    position: absolute;
    width: 100vw;
    z-index: 5;
}
</style>
